import script from "./ModalContentComponent.vue?vue&type=script&lang=js"
export * from "./ModalContentComponent.vue?vue&type=script&lang=js"

export default script